module.exports = __webpack_public_path__ + "assets/gov-orange-lg-logo-919508.svg";